import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  constructor(private http: HttpClient, private restService: RestService) {}

  dashboard(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('dashboard', val_params);
  }

  dashboardGeneralService(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('dashboard/general-service', val_params);
  }

  listCategoryStars(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/categorystars/list', val_params);
  }

  listShiftTours(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/shifttours/list', val_params);
  }

  listVehiclesTours(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/vehicletours/list', val_params);
  }

  listVideosTourism(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/videos/tourism/list', val_params);
  }

  listTypeClient(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typeclient/list', val_params);
  }

  listTypeDocument(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typedocuments/list', val_params);
  }

  listStatusMarital(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/statusmarital/list', val_params);
  }

  listSexs(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/sexs/list', val_params);
  }

  extractDni(val_param: any) {
    return this.restService.get('services/dni', val_param);
  }

  extractRuc(val_param: any) {
    return this.restService.get('services/ruc', val_param);
  }

  listOriginBooking(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/originbooking/list', val_params);
  }

  listArrivalBooking(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/arrivalbooking/list', val_params);
  }

  listConceptIncomes(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/concept/incomes', val_params);
  }

  saveConceptIncomes(data: any) {
    return this.restService.save('config/concept/incomes/save', data);
  }

  listConceptExpenses(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/concept/expenses', val_params);
  }

  saveConceptExpenses(data: any) {
    return this.restService.save('config/concept/expenses/save', data);
  }

  listPaymentmethods(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/paymentmethods', val_params);
  }

  listCurrencies(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/currency', val_params);
  }

  listTypeVoucher(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typevoucher', val_params);
  }

  listTypeVoucherSale(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typevoucher/sale', val_params);
  }

  listTypeVoucherBooking(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typevoucher/bookings', val_params);
  }

  listTypeVoucherBookingByOffice(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all(
      'config/typevoucher/bookings_by_office',
      val_params
    );
  }

  listUnitmeasureParents(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/unitsmeasure/parents', val_params);
  }

  listTypePrices(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typeprices', val_params);
  }

  getUnitmeasuresChilds(val_id: number) {
    return this.restService.get('config/unitsmeasure/childs', val_id);
  }

  listTax(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/tax', val_params);
  }

  listTypeTransactions(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/typetransaction', val_params);
  }

  listOriginSales(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/originsales', val_params);
  }

  listVirtualChannels(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/virtualchannels', val_params);
  }

  getSerieTypeVoucher(val_id: number) {
    return this.restService.get('config/typevoucher/serie', val_id);
  }

  getByVoucherAndBranchOffice(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all(
      'config/typevoucher/serie_branchoffice',
      val_params
    );
  }

  listVehicleType(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/vehicletype', val_params);
  }

  saveVehicleType(data: any) {
    return this.restService.save('config/vehicletype/save', data);
  }

  listWorkingGroup(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/workinggroup', val_params);
  }

  searchAirport(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('airport/search', val_params);
  }

  listCountries(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/countries/list', val_params);
  }

  listTypeChargeHotel(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotel/typecharge/all', val_params);
  }

  listTableTypes(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/table/types/all', val_params);
  }
}
